import { render } from "./IconNotify.vue?vue&type=template&id=ebda12a8&scoped=true&ts=true"
import script from "./IconNotify.vue?vue&type=script&lang=ts"
export * from "./IconNotify.vue?vue&type=script&lang=ts"

import "./IconNotify.vue?vue&type=style&index=0&id=ebda12a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebda12a8"]])

export default __exports__